@if (isPaymentOverdue()) {
  <div
    class="subscription-banner"
    data-cy="sana-tp-subscription-banner">
    <p-message severity="warn">{{ message }}</p-message>
  </div>
}
